import { render, staticRenderFns } from "./DropZoneMulti.vue?vue&type=template&id=670a74b7"
import script from "./DropZoneMulti.vue?vue&type=script&lang=js"
export * from "./DropZoneMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports